import { Container } from '@tencent/alloy-renderer';
import {
    IBaseComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/base-component.interface';

export abstract class BaseComponent extends Container implements IBaseComponent {
    public abstract getUniqueId(): string;
    public abstract getComponentType(): string;
}
